/* VELNA Somn -- quantity-aware pricing + cart drawer.
   Self-contained: injects its own styles and markup, patches fetch to catch
   every /cart/add.js the theme already makes. Loaded on every page. */
(function () {
  'use strict';
  if (window.__vsSomnCart) return;
  window.__vsSomnCart = true;

  var D = document;
  function $(sel, root) { return (root || D).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || D).querySelectorAll(sel)); }

  /* ------------------------------------------------------ money helpers */
  var fmt = { prefix: '$', suffix: '' };
  function learnFormat(str) {
    if (!str) return;
    var m = String(str).match(/^([^\d]*)[\d.,\s]+([^\d]*)$/);
    if (m) { fmt.prefix = m[1] || ''; fmt.suffix = m[2] || ''; }
  }
  function toNumber(str) {
    if (!str) return 0;
    var s = String(str).replace(/[^\d.,]/g, '').trim();
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) {
      s = s.lastIndexOf(',') > s.lastIndexOf('.') ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
    } else if (s.indexOf(',') > -1) {
      s = /,\d{2}$/.test(s) ? s.replace(',', '.') : s.replace(/,/g, '');
    }
    return parseFloat(s) || 0;
  }
  function money(value) {
    return fmt.prefix + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + fmt.suffix;
  }
  function moneyFromCents(cents) { return money((cents || 0) / 100); }

  /* --------------------------------------------- qty-aware button price */
  function bindQuantityPricing(scope) {
    var forms = $$('form[action*="/cart/add"]', scope);
    forms.forEach(function (form) {
      if (form.__vsQty) return;
      form.__vsQty = true;
      var root = form.closest('[data-vs-main]') || form.closest('section') || D;
      var qtyInput = $('[data-vs-qty-input]', form) || $('input[name="quantity"]', form);
      var buttonPrice = $('[data-vs-button-price]', form);
      if (!qtyInput || !buttonPrice) return;

      learnFormat(buttonPrice.textContent);
      var unit = toNumber(buttonPrice.textContent);
      if (!unit) return;

      function activeUnit() {
        var active = $('[data-vs-choice].is-active', root);
        if (active && active.getAttribute('data-vs-price')) {
          var v = toNumber(active.getAttribute('data-vs-price'));
          if (v) return v;
        }
        return unit;
      }
      function render() {
        var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        var total = activeUnit() * qty;
        buttonPrice.textContent = money(total);
        $$('[data-vs-sticky-price]').forEach(function (el) { el.textContent = money(total); });
      }
      ['change', 'input', 'keyup'].forEach(function (ev) { qtyInput.addEventListener(ev, render); });
      $$('[data-vs-qty]', form).forEach(function (b) {
        b.addEventListener('click', function () { window.setTimeout(render, 0); });
      });
      $$('[data-vs-choice]', root).forEach(function (c) {
        c.addEventListener('click', function () { window.setTimeout(render, 0); });
      });
      render();
    });
  }

  /* ------------------------------------------------------------- styles */
  var CSS = [
    '.vs-drawer-backdrop{position:fixed;inset:0;background:rgba(32,29,25,.42);opacity:0;visibility:hidden;transition:opacity .3s ease,visibility .3s ease;z-index:2147483000}',
    '.vs-drawer-backdrop.is-open{opacity:1;visibility:visible}',
    '.vs-drawer{position:fixed;top:0;right:0;height:100%;width:min(400px,92vw);background:#F7F4EE;color:#26231F;border-left:1px solid #DED5C6;transform:translateX(102%);transition:transform .34s cubic-bezier(.22,.61,.36,1);z-index:2147483001;display:flex;flex-direction:column;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif;box-shadow:-18px 0 48px rgba(40,34,27,.14)}',
    '.vs-drawer.is-open{transform:translateX(0)}',
    '.vs-drawer-head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px 16px;border-bottom:1px solid #E4DCCF}',
    '.vs-drawer .vs-drawer-head h2{margin:0;font-size:10px;letter-spacing:.18em;text-transform:uppercase;font-weight:600;color:#4A443B !important}',
    '.vs-drawer-close{background:none;border:0;font-size:22px;line-height:1;cursor:pointer;color:#4A443B;padding:2px 4px}',
    '.vs-drawer-body{flex:1;overflow-y:auto;padding:6px 22px 10px}',
    '.vs-drawer-empty{padding:56px 0;text-align:center;color:#6B655B;font-size:13px;line-height:1.6}',
    '.vs-line{display:grid;grid-template-columns:64px 1fr;gap:14px;padding:18px 0;border-bottom:1px solid #E9E2D6}',
    '.vs-line:last-child{border-bottom:0}',
    '.vs-line-img{width:64px;height:64px;object-fit:cover;background:#ECE6DC;border:1px solid #E4DCCF}',
    '.vs-line-title{margin:0 0 3px;font-size:14px;font-weight:600;line-height:1.3}',
    '.vs-drawer .vs-line-title a{color:inherit !important;text-decoration:none !important}',
    '.vs-line-variant{margin:0 0 9px;font-size:11px;color:#7A7264}',
    '.vs-line-foot{display:flex;align-items:center;justify-content:space-between;gap:10px}',
    '.vs-qty{display:inline-flex;align-items:center;border:1px solid #DED5C6;background:#fff}',
    '.vs-qty button{width:26px;height:26px;border:0;background:none;cursor:pointer;font-size:14px;line-height:1;color:#3A342C}',
    '.vs-qty span{min-width:24px;text-align:center;font-size:12px}',
    '.vs-drawer .vs-line-price{font-size:14px;font-weight:600;white-space:nowrap;color:#26231F !important}',
    '.vs-drawer .vs-line-remove{background:none;border:0;padding:0;margin-top:7px;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#8A8173 !important;cursor:pointer;text-decoration:underline;text-underline-offset:3px}',
    '.vs-drawer-foot{border-top:1px solid #E4DCCF;padding:18px 22px 22px;background:#F2EEE6}',
    '.vs-sub{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:4px}',
    '.vs-sub span{font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:#6B655B}',
    '.vs-drawer .vs-sub strong{font-size:20px;color:#26231F !important}',
    '.vs-note{margin:0 0 14px;font-size:11px;color:#7A7264}',
    '.vs-drawer .vs-checkout{display:block;width:100%;border:0;background:#26231F !important;color:#fff !important;-webkit-text-fill-color:#fff;padding:15px 10px;font-size:10px;letter-spacing:.18em;text-transform:uppercase;font-weight:600;cursor:pointer;text-align:center;text-decoration:none !important}',
    '.vs-drawer .vs-checkout:hover{background:#3A342C !important}',
    '.vs-drawer .vs-viewcart{display:block;text-align:center;margin-top:11px;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#6B655B !important;-webkit-text-fill-color:#6B655B;text-decoration:underline !important;text-underline-offset:3px}',
    '.vs-drawer .vs-line-price s{color:#9C9384 !important;-webkit-text-fill-color:#9C9384;font-weight:400;margin-right:6px;text-decoration-thickness:1px}',
    '.vs-promo{margin:0 0 15px}',
    '.vs-promo-row{display:flex;gap:8px}',
    '.vs-drawer .vs-promo input{flex:1;min-width:0;border:1px solid #DED5C6;background:#fff;padding:11px 12px;font-family:inherit;font-size:12px;line-height:1.2;color:#26231F !important;-webkit-text-fill-color:#26231F;letter-spacing:.06em;text-transform:uppercase}',
    '.vs-drawer .vs-promo input::placeholder{color:#9C9384;-webkit-text-fill-color:#9C9384;font-size:10px;letter-spacing:.14em;text-transform:uppercase}',
    '.vs-drawer .vs-promo input:focus{outline:0;border-color:#26231F}',
    '.vs-drawer .vs-promo-apply{border:1px solid #26231F;background:#fff;color:#26231F !important;-webkit-text-fill-color:#26231F;padding:0 16px;font-family:inherit;font-size:9px;letter-spacing:.16em;text-transform:uppercase;font-weight:600;cursor:pointer;white-space:nowrap}',
    '.vs-drawer .vs-promo-apply:hover{background:#26231F;color:#fff !important;-webkit-text-fill-color:#fff}',
    '.vs-drawer .vs-promo-apply[disabled]{opacity:.45;cursor:default;background:#fff;color:#26231F !important;-webkit-text-fill-color:#26231F}',
    '.vs-promo-msg{margin:8px 0 0;font-size:11px;line-height:1.45;color:#6B655B}',
    '.vs-promo-msg.is-bad{color:#8C3A1B}',
    '.vs-promo-tags{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 10px}',
    '.vs-promo-tag{display:inline-flex;align-items:center;gap:8px;border:1px solid #C9B27A;background:#F8F3E8;padding:5px 8px 5px 10px;font-size:10px;letter-spacing:.11em;text-transform:uppercase;font-weight:600;color:#5B4B22}',
    '.vs-drawer .vs-promo-tag button{border:0;background:none;padding:0;font-size:14px;line-height:1;cursor:pointer;color:#8A7333 !important;-webkit-text-fill-color:#8A7333}',
    '.vs-row{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:5px;font-size:11px;color:#6B655B}',
    '.vs-drawer .vs-row span:last-child{color:#3A342C !important;white-space:nowrap}',
    '.vs-drawer .vs-row.is-save span{color:#6F5A1E !important}',
    '.vs-pa{display:flex}',
    '.vs-pay{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:6px;margin-top:13px}',
    '.vs-pay svg,.vs-pay img{height:22px;width:auto;display:block}',
    '.vs-cart-link{position:relative}',
    '.vs-cart-badge{position:absolute;top:-7px;right:-9px;min-width:16px;height:16px;padding:0 4px;border-radius:9px;background:#26231F;color:#fff;font-size:9px;font-weight:700;line-height:16px;text-align:center;letter-spacing:0}',
    '.vs-cart-badge[hidden]{display:none}',
    '.vs-toast{position:fixed;left:50%;bottom:26px;transform:translate(-50%,14px);background:#26231F !important;color:#fff !important;-webkit-text-fill-color:#fff;padding:12px 20px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;opacity:0;visibility:hidden;transition:.28s ease;z-index:2147483002}',
    '.vs-toast.is-on{opacity:1;visibility:visible;transform:translate(-50%,0)}',
    '@media(prefers-reduced-motion:reduce){.vs-drawer,.vs-drawer-backdrop,.vs-toast{transition:none}}'
  ].join('');

  function injectCss() {
    if ($('#vs-somn-cart-css')) return;
    var st = D.createElement('style');
    st.id = 'vs-somn-cart-css';
    st.textContent = CSS;
    D.head.appendChild(st);
  }

  /* -------------------------------------------------------------- markup */
  var backdrop, drawer, body, foot, toastEl, lastFocus;

  function build() {
    if (drawer) return;
    injectCss();
    backdrop = D.createElement('div');
    backdrop.className = 'vs-drawer-backdrop';
    backdrop.addEventListener('click', close);

    drawer = D.createElement('aside');
    drawer.className = 'vs-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Your cart');
    drawer.innerHTML =
      '<div class="vs-drawer-head"><h2>Your cart</h2>' +
      '<button class="vs-drawer-close" type="button" aria-label="Close cart">&times;</button></div>' +
      '<div class="vs-drawer-body"></div>' +
      '<div class="vs-drawer-foot"></div>';
    body = $('.vs-drawer-body', drawer);
    foot = $('.vs-drawer-foot', drawer);
    $('.vs-drawer-close', drawer).addEventListener('click', close);

    toastEl = D.createElement('div');
    toastEl.className = 'vs-toast';
    toastEl.setAttribute('role', 'status');

    D.body.appendChild(backdrop);
    D.body.appendChild(drawer);
    D.body.appendChild(toastEl);

    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function toast(msg) {
    build();
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    window.clearTimeout(toast._t);
    toast._t = window.setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function open() {
    build();
    lastFocus = D.activeElement;
    backdrop.classList.add('is-open');
    drawer.classList.add('is-open');
    D.documentElement.style.overflow = 'hidden';
    var c = $('.vs-drawer-close', drawer);
    if (c) c.focus();
  }
  function close() {
    if (!drawer) return;
    backdrop.classList.remove('is-open');
    drawer.classList.remove('is-open');
    D.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------------------------------------------------------- rendering */
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function api(path) { return root().replace(/\/$/, '') + path; }

  function render(cart) {
    build();
    if (!cart || !cart.items || !cart.items.length) {
      body.innerHTML = '<p class="vs-drawer-empty">Your cart is empty for now.<br>The evening can wait.</p>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? String(item.image).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      return '<div class="vs-line" data-key="' + item.key + '">' +
        (img ? '<img class="vs-line-img" src="' + img + '" alt="" width="64" height="64" loading="lazy">'
             : '<span class="vs-line-img"></span>') +
        '<div><p class="vs-line-title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
        (variant ? '<p class="vs-line-variant">' + variant + '</p>' : '') +
        '<div class="vs-line-foot"><span class="vs-qty">' +
          '<button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
        '</span>' + linePrice(item) + '</div>' +
        '<button class="vs-line-remove" type="button" data-remove>Remove</button>' +
        '</div></div>';
    }).join('');

    var codes = goodCodes(cart);
    var saved = cart.total_discount || 0;
    var gross = saved > 0
      ? (cart.original_total_price || (cart.total_price + saved))
      : cart.total_price;

    foot.innerHTML =
      promoBlock(codes) +
      (saved > 0
        ? '<div class="vs-row"><span>Subtotal</span><span>' + moneyFromCents(gross) + '</span></div>' +
          '<div class="vs-row is-save"><span>Discount' +
            (codes.length ? ' &middot; ' + escapeHtml(codes.map(function (c) { return c.code; }).join(', ')) : '') +
          '</span><span>&minus;' + moneyFromCents(saved) + '</span></div>'
        : '') +
      '<div class="vs-sub"><span>' + (saved > 0 ? 'Total' : 'Subtotal') + '</span><strong>' +
        moneyFromCents(cart.total_price) + '</strong></div>' +
      '<p class="vs-note">Shipping and taxes are calculated at checkout.</p>' +
      '<a class="vs-checkout" href="' + api('/checkout') + '">Checkout</a>' +
      payments() +
      '<a class="vs-viewcart" href="' + api('/cart') + '">View cart</a>';

    bindPromo();

    $$('.vs-line', body).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var qtyNow = parseInt($('.vs-qty span', line).textContent, 10) || 1;
      $$('.vs-qty button', line).forEach(function (b) {
        b.addEventListener('click', function () {
          change(key, Math.max(0, qtyNow + parseInt(b.getAttribute('data-step'), 10)));
        });
      });
      $('[data-remove]', line).addEventListener('click', function () { change(key, 0); });
    });
  }

  /* ------------------------------------------------------- promo codes */
  /* Shopify has no AJAX endpoint for discount codes. Hitting /discount/CODE
     stores the code against the session cart, after which /cart.js reports it
     in discount_codes with an `applicable` flag and the totals already
     reflect it. Clearing is POST /cart/update.js with an empty discount, so
     removing one code from a stack means clearing and re-applying the rest. */
  var promo = { msg: '', bad: false, busy: false, draft: '' };

  function promoBlock(codes) {
    var tags = codes.length
      ? '<div class="vs-promo-tags">' + codes.map(function (c) {
          return '<span class="vs-promo-tag">' + escapeHtml(c.code) +
            '<button type="button" data-drop-code="' + escapeHtml(c.code) +
            '" aria-label="Remove code ' + escapeHtml(c.code) + '">&times;</button></span>';
        }).join('') + '</div>'
      : '';
    return '<div class="vs-promo">' + tags +
      '<div class="vs-promo-row">' +
        '<input type="text" name="vs-promo" autocomplete="off" spellcheck="false" ' +
          'aria-label="Promo code" placeholder="Promo code" value="' + escapeHtml(promo.draft) + '">' +
        '<button class="vs-promo-apply" type="button"' + (promo.busy ? ' disabled' : '') + '>' +
          (promo.busy ? 'Applying' : 'Apply') + '</button>' +
      '</div>' +
      (promo.msg ? '<p class="vs-promo-msg' + (promo.bad ? ' is-bad' : '') + '">' + escapeHtml(promo.msg) + '</p>' : '') +
      '</div>';
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function readCart() {
    return fetch(api('/cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function goodCodes(cart) {
    return (cart && cart.discount_codes ? cart.discount_codes : []).filter(function (c) {
      return c && c.applicable;
    });
  }

  /* Clear every stored code, then put back the ones in `keep`. */
  function resetCodes(keep) {
    return fetch(api('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function () {
      return (keep || []).reduce(function (chain, c) {
        return chain.then(function () {
          return fetch(api('/discount/' + encodeURIComponent(c.code)), { cache: 'no-store' });
        });
      }, Promise.resolve());
    }).then(readCart);
  }

  function applyCode(code) {
    code = String(code || '').trim();
    if (!code || promo.busy) return;
    promo.busy = true;
    promo.msg = '';
    promo.bad = false;
    promo.draft = code;
    readCart().then(function (before) {
      var had = goodCodes(before).map(function (c) { return c.code.toUpperCase(); });
      if (had.indexOf(code.toUpperCase()) > -1) {
        promo.busy = false;
        promo.draft = '';
        promo.msg = 'That code is already applied.';
        render(before);
        return null;
      }
      render(before);
      return fetch(api('/discount/' + encodeURIComponent(code)), { cache: 'no-store' })
        .then(readCart)
        .then(function (cart) {
          var rejected = (cart.discount_codes || []).filter(function (c) { return c && !c.applicable; });
          if (!rejected.length) {
            promo.busy = false;
            promo.draft = '';
            promo.msg = '';
            render(cart);
            syncCount(cart);
            toast('Promo code applied');
            return cart;
          }
          /* Shopify keeps a rejected code in the stack -- take it back out. */
          return resetCodes(goodCodes(cart)).then(function (clean) {
            promo.busy = false;
            promo.bad = true;
            promo.msg = 'This code cannot be used with the items in your cart.';
            render(clean);
            syncCount(clean);
            return clean;
          });
        });
    }).catch(function () {
      promo.busy = false;
      promo.bad = true;
      promo.msg = 'Could not reach the store. Please try again.';
      readCart().then(render).catch(function () {});
    });
  }

  function dropCode(code) {
    if (promo.busy) return;
    promo.busy = true;
    promo.msg = '';
    promo.bad = false;
    readCart().then(function (cart) {
      var keep = goodCodes(cart).filter(function (c) {
        return c.code.toUpperCase() !== String(code).toUpperCase();
      });
      return resetCodes(keep);
    }).then(function (cart) {
      promo.busy = false;
      render(cart);
      syncCount(cart);
    }).catch(function () {
      promo.busy = false;
      promo.bad = true;
      promo.msg = 'Could not remove the code. Please try again.';
      readCart().then(render).catch(function () {});
    });
  }

  function bindPromo() {
    var input = $('.vs-promo input', foot);
    var btn = $('.vs-promo-apply', foot);
    if (!input || !btn) return;
    input.addEventListener('input', function () { promo.draft = input.value; });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyCode(input.value); }
    });
    btn.addEventListener('click', function () { applyCode(input.value); });
    $$('[data-drop-code]', foot).forEach(function (b) {
      b.addEventListener('click', function () { dropCode(b.getAttribute('data-drop-code')); });
    });
  }

  /* With a code applied Shopify allocates the saving onto the lines, so
     line_price can read 0. Show what the line was worth alongside it. */
  function linePrice(item) {
    var was = item.original_line_price;
    var now = item.line_price;
    if (was && was !== now) {
      return '<span class="vs-line-price"><s>' + moneyFromCents(was) + '</s>' +
        moneyFromCents(now) + '</span>';
    }
    return '<span class="vs-line-price">' + moneyFromCents(now) + '</span>';
  }

  function payments() {
    var src = D.getElementById('vs-payment-icons');
    if (!src || !src.innerHTML.replace(/\s/g, '')) return '';
    return '<div class="vs-pay">' + src.innerHTML + '</div>';
  }

  function change(key, quantity) {
    fetch(api('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncCount(cart); })
      .catch(function () {});
  }

  function load(thenOpen) {
    fetch(api('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncCount(cart); if (thenOpen) open(); })
      .catch(function () { if (thenOpen) open(); });
  }

  function syncCount(cart) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (n === null) return;
    $$('[data-cart-count],[data-somn-cart-count],.cart-count,.js-cart-count,.vs-cart-badge').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* --------------------------------------------- catch every cart add */
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = /\/cart\/add(\.js)?/.test(url);
      var call = nativeFetch.apply(this, arguments);
      if (!isAdd) return call;
      return call.then(function (res) {
        if (res && res.ok) {
          toast('Added to cart');
          window.setTimeout(function () { load(true); }, 120);
        }
        return res;
      });
    };
  }

  /* open the drawer instead of walking to /cart */
  function bindCartLinks() {
    $$('a[href$="/cart"], a[href*="/cart?"], [data-vs-cart-open]').forEach(function (a) {
      if (a.__vsBound) return;
      a.__vsBound = true;
      injectCss();
      if (/\/cart$/.test(a.getAttribute('href') || '') && !$('.vs-cart-badge', a)) {
        a.classList.add('vs-cart-link');
        var badge = D.createElement('span');
        badge.className = 'vs-cart-badge';
        badge.hidden = true;
        badge.setAttribute('aria-hidden', 'true');
        a.appendChild(badge);
      }
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        e.preventDefault();
        load(true);
      });
    });
  }

  function boot() {
    bindQuantityPricing(D);
    bindCartLinks();
    fetch(api('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(syncCount)
      .catch(function () {});
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
  D.addEventListener('shopify:section:load', function (e) {
    bindQuantityPricing(e.target || D);
    bindCartLinks();
  });
})();
